import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnChanges } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ToolService } from '@app/core/services/tool/tool.service';

@Component({
  selector: 'app-visitor-services',
  templateUrl: './visitor-services.component.html',
  styleUrls: ['./visitor-services.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class SidebarVisitorServicesComponent implements OnChanges {
  @Input() application: any;
  textcontent: any;
  generalView = false;
  constructor(
    private toolService: ToolService
  ) { }

  ngOnChanges() {
    if (this.application === undefined || null) {
      this.generalView = true;
    }
    this.toolService.content.subscribe((textcontent: any) => this.textcontent = textcontent);
  }

  openServices = () => {
    window.open(this.textcontent.basic.url.services, '_blank');
  }

}
